/* Rescuevation · Löschrucksack Premium (rescu-lrp-*), 15.10.2026

   Bewegung ist ADDITIV: Ohne JavaScript, bei reduzierter Bewegung und wenn ein
   Beobachter nie auslöst, steht jedes Element im fertigen Zustand. Dieses Script
   legt nur einmalige Keyframe-Läufe darüber (Klasse lrp-go, nach animationend
   wieder entfernt) und startet Schleifen nur, solange sie zu sehen sind.

   Kaufen: /cart/add.js, danach die Warenkorb-Schublade. Die Section-Liste kommt
   von der Schublade selbst (getSectionsToRender), weil die Live-Schublade b4c
   andere Sections rendert als Dawns Standard. */
(function () {
  'use strict';
  if (window.__rlrp) return;
  window.__rlrp = true;

  var doc = document.documentElement;
  doc.classList.add('lrp-js', 'lrp-bereit');

  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hatIO = 'IntersectionObserver' in window;
  var feinZeiger = window.matchMedia('(pointer: fine)').matches;
  var zahlFmt = new Intl.NumberFormat('de-DE');
  var vh = function () { return window.innerHeight || doc.clientHeight; };
  var alle = function (wurzel, sel) { return Array.prototype.slice.call(wurzel.querySelectorAll(sel)); };
  var imBild = function (el) { var r = el.getBoundingClientRect(); return r.top < vh() && r.bottom > 0; };
  var komma = function (wert, stellen) {
    return wert.toLocaleString('de-DE', { minimumFractionDigits: stellen, maximumFractionDigits: stellen });
  };
  var geld = function (cent) { return komma(cent / 100, 2); };

  /* ---------- Einmalige Läufe ---------- */

  /* Welche Keyframes eine Klasse beendet; ohne Eintrag zählt nur die Zeit,
     weil dort mehrere Läufe (auch an Kindern) zusammengehören. */
  var LAUF = { 'lrp-go': 'lrp-auf', 'lrp-linie-go': 'lrp-linie' };

  function einmal(el, klasse, dauer) {
    klasse = klasse || 'lrp-go';
    var schluessel = '__lrp_' + klasse;
    if (el[schluessel]) return;
    el[schluessel] = true;
    el.classList.add(klasse);
    var fertig = false;
    var name = LAUF[klasse];
    var ende = function (e) {
      if (fertig) return;
      if (e && (e.target !== el || e.animationName !== name)) return;
      fertig = true;
      el.classList.remove(klasse);
      el.removeEventListener('animationend', ende);
    };
    if (name) el.addEventListener('animationend', ende);
    setTimeout(function () { ende(); }, dauer || 2600);
  }

  function neuStarten(el, klasse) {
    el.classList.remove(klasse);
    void el.offsetWidth;
    el.classList.add(klasse);
  }

  function staffeln(liste) {
    var gruppen = new Map();
    liste.forEach(function (el) {
      var g = el.parentElement;
      var n = gruppen.get(g) || 0;
      el.style.setProperty('--lrp-d', Math.min(n * 90, 540) + 'ms');
      gruppen.set(g, n + 1);
    });
  }

  function einblenden() {
    if (ruhig || !hatIO) return;
    var els = alle(document, '.lrp [data-lrp-in]');
    staffeln(els);
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        einmal(e.target);
      });
    }, { rootMargin: '0px 0px 4% 0px' });
    els.forEach(function (el) { if (!imBild(el)) io.observe(el); });

    var linien = alle(document, '.lrp [data-lrp-linie]');
    var io2 = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        io2.unobserve(e.target);
        einmal(e.target, 'lrp-linie-go', 2200);
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    linien.forEach(function (el) { if (!imBild(el)) io2.observe(el); });
  }

  /* ---------- Schleifen nur, solange sichtbar ---------- */

  function schleifen() {
    if (ruhig || !hatIO) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { e.target.classList.toggle('lrp-spielt', e.isIntersecting); });
    }, { threshold: 0.08 });
    alle(document, '.lrp[data-lrp-spiel], .lrp [data-lrp-spiel]').forEach(function (el) { io.observe(el); });
  }

  /* ---------- Kennzahlen zählen einmal hoch ---------- */

  function zaehle(el, verzoegerung) {
    var ziel = parseInt(String(el.getAttribute('data-lrp-zahl')).replace(/\D/g, ''), 10);
    if (!ziel || ziel <= 0) return;
    var endText = el.textContent;
    var t0 = null;
    var dauer = ziel >= 1000 ? 1900 : 1400;
    var schritt = function (t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dauer);
      var w = 1 - Math.pow(1 - p, 4);
      el.textContent = zahlFmt.format(Math.round(ziel * w));
      if (p < 1) requestAnimationFrame(schritt); else el.textContent = endText;
    };
    setTimeout(function () { el.textContent = '0'; requestAnimationFrame(schritt); }, verzoegerung || 0);
  }

  function zaehlen() {
    if (ruhig || !hatIO) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        zaehle(e.target, 120);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    alle(document, '.lrp [data-lrp-zahl]').forEach(function (el) {
      if (el.hasAttribute('data-lrp-zahl-sofort')) return;
      io.observe(el);
    });
  }

  /* ---------- Bühne: Füllstand, Lichtkegel am Zeiger ---------- */

  function buehne() {
    alle(document, '[data-lrp-fuell]').forEach(function (karte) {
      if (ruhig) return;
      einmal(karte, 'lrp-fuellt', 3000);
      var zahl = karte.querySelector('[data-lrp-zahl-sofort]');
      if (zahl) zaehle(zahl, 520);
    });
    if (ruhig || !feinZeiger) return;
    alle(document, '[data-lrp-spot]').forEach(function (sec) {
      var plan = null;
      sec.addEventListener('pointermove', function (e) {
        if (plan) return;
        plan = requestAnimationFrame(function () {
          plan = null;
          var r = sec.getBoundingClientRect();
          sec.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          sec.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        });
      });
    });
  }

  /* ---------- Glutfunken ---------- */

  function funken() {
    if (ruhig) return;
    alle(document, '[data-lrp-funken]').forEach(function (cv) {
      var ctx = cv.getContext && cv.getContext('2d');
      if (!ctx) return;
      var sec = cv.parentElement;
      var b = 0, h = 0, dpr = Math.min(2, window.devicePixelRatio || 1);
      var teile = [];
      var laeuft = false, plan = null, letzte = 0;
      var FARBEN = [[245, 215, 0], [255, 236, 140], [178, 17, 14], [255, 255, 255]];
      function groesse() {
        b = sec.clientWidth; h = sec.clientHeight;
        cv.width = Math.round(b * dpr); cv.height = Math.round(h * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var ziel = Math.min(70, Math.round(b / 20));
        while (teile.length < ziel) teile.push(neu(true));
        teile.length = ziel;
      }
      function neu(irgendwo) {
        var f = FARBEN[Math.random() < 0.55 ? 0 : (Math.random() < 0.6 ? 1 : (Math.random() < 0.7 ? 2 : 3))];
        return {
          x: Math.random() * b,
          y: irgendwo ? Math.random() * h : h + Math.random() * 40,
          vy: -(0.25 + Math.random() * 0.9),
          vx: (Math.random() - 0.5) * 0.35,
          r: 0.7 + Math.random() * 1.9,
          a: 0.25 + Math.random() * 0.6,
          ph: Math.random() * Math.PI * 2,
          f: f
        };
      }
      function bild(t) {
        if (!laeuft) return;
        var dt = Math.min(48, t - (letzte || t)) / 16.7;
        letzte = t;
        ctx.clearRect(0, 0, b, h);
        ctx.globalCompositeOperation = 'lighter';
        for (var i = 0; i < teile.length; i++) {
          var p = teile[i];
          p.ph += 0.05 * dt;
          p.x += (p.vx + Math.sin(p.ph) * 0.25) * dt;
          p.y += p.vy * dt;
          var hoehe = 1 - p.y / h;
          var alpha = p.a * Math.max(0, Math.min(1, 1.2 - hoehe)) * (0.65 + 0.35 * Math.sin(p.ph * 3));
          if (p.y < -10 || alpha <= 0.01) { teile[i] = neu(false); continue; }
          ctx.fillStyle = 'rgba(' + p.f[0] + ',' + p.f[1] + ',' + p.f[2] + ',' + (alpha * 0.25).toFixed(3) + ')';
          ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 3.2, 0, 6.283); ctx.fill();
          ctx.fillStyle = 'rgba(' + p.f[0] + ',' + p.f[1] + ',' + p.f[2] + ',' + alpha.toFixed(3) + ')';
          ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283); ctx.fill();
        }
        plan = requestAnimationFrame(bild);
      }
      function an() { if (laeuft) return; laeuft = true; letzte = 0; plan = requestAnimationFrame(bild); }
      function aus() { laeuft = false; if (plan) cancelAnimationFrame(plan); }
      groesse();
      if ('ResizeObserver' in window) new ResizeObserver(groesse).observe(sec);
      if (hatIO) {
        new IntersectionObserver(function (e) { if (e[0].isIntersecting && !document.hidden) an(); else aus(); }).observe(sec);
      } else an();
      document.addEventListener('visibilitychange', function () { if (document.hidden) aus(); else if (imBild(sec)) an(); });
    });
  }

  /* ---------- Galerie ---------- */

  function galerie() {
    alle(document, '[data-lrp-galerie]').forEach(function (g) {
      var band = g.querySelector('[data-lrp-band]');
      var minis = alle(g, '[data-lrp-mini]');
      if (!band) return;
      var bilder = alle(band, '.lrp-galerie__bild');
      var aktuell = 0;
      var gehe = function (i) {
        i = Math.max(0, Math.min(bilder.length - 1, i));
        band.scrollTo({ left: bilder[i].offsetLeft, behavior: ruhig ? 'auto' : 'smooth' });
      };
      var markieren = function () {
        var i = Math.round(band.scrollLeft / Math.max(1, band.clientWidth));
        if (i === aktuell) return;
        aktuell = i;
        minis.forEach(function (m, n) { m.setAttribute('aria-current', n === i ? 'true' : 'false'); });
        var zaehler = g.querySelector('[data-lrp-zaehler]');
        if (zaehler) zaehler.textContent = String(i + 1);
        var m = minis[i];
        if (m && m.parentElement) {
          var reihe = m.parentElement;
          reihe.scrollTo({ left: m.offsetLeft - reihe.clientWidth / 2 + m.clientWidth / 2, behavior: ruhig ? 'auto' : 'smooth' });
        }
      };
      band.addEventListener('scroll', function () { window.requestAnimationFrame(markieren); }, { passive: true });
      minis.forEach(function (m, i) { m.addEventListener('click', function () { gehe(i); }); });
      var vor = g.querySelector('[data-lrp-vor]');
      var zurueck = g.querySelector('[data-lrp-zurueck]');
      if (vor) vor.addEventListener('click', function () { gehe(aktuell + 1 >= bilder.length ? 0 : aktuell + 1); });
      if (zurueck) zurueck.addEventListener('click', function () { gehe(aktuell - 1 < 0 ? bilder.length - 1 : aktuell - 1); });
      band.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); gehe(aktuell + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); gehe(aktuell - 1); }
      });
    });
  }

  /* ---------- Warenkorb ---------- */

  function inDenWarenkorb(items) {
    var schublade = document.querySelector('cart-drawer');
    var body = { items: items };
    if (schublade && typeof schublade.getSectionsToRender === 'function') {
      body.sections = schublade.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (daten) {
        if (!res.ok || daten.status) throw new Error(daten.description || daten.message || 'HTTP ' + res.status);
        return daten;
      });
    }).then(function (daten) {
      try {
        if (schublade && typeof schublade.renderContents === 'function' && daten.sections) {
          schublade.classList.remove('is-empty');
          schublade.renderContents(daten);
        } else {
          window.location.href = root + 'cart';
        }
      } catch (e) {
        /* Artikel liegt schon im Korb: nicht noch einmal senden, sondern zur Warenkorbseite */
        window.location.href = root + 'cart';
      }
      return daten;
    });
  }

  var HAKEN = '<svg class="lrp-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 12.5l4.8 4.8L19.5 7"/></svg>';

  function knopfLaeuft(btn, an) {
    if (!btn) return;
    if (an) {
      if (!btn.__lrpLabel) btn.__lrpLabel = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<span>Wird hinzugefügt …</span>';
    } else {
      btn.disabled = false;
      if (btn.__lrpLabel) btn.innerHTML = btn.__lrpLabel;
    }
  }

  function knopfOk(btn) {
    if (!btn) return;
    var label = btn.__lrpLabel || btn.innerHTML;
    btn.disabled = false;
    btn.classList.add('ist-ok');
    btn.innerHTML = HAKEN + '<span>Im Warenkorb</span>';
    setTimeout(function () { btn.classList.remove('ist-ok'); btn.innerHTML = label; btn.__lrpLabel = null; }, 2400);
  }

  function kaufMit(btn, items, fehlerEl) {
    if (fehlerEl) { fehlerEl.hidden = true; fehlerEl.textContent = ''; }
    knopfLaeuft(btn, true);
    return inDenWarenkorb(items).then(function () {
      knopfOk(btn);
    }).catch(function (err) {
      knopfLaeuft(btn, false);
      if (fehlerEl) {
        fehlerEl.hidden = false;
        fehlerEl.textContent = (err && err.message) ? err.message : 'Das hat nicht geklappt. Versuch es noch einmal oder ruf uns an.';
      }
    });
  }

  function stepper() {
    alle(document, '[data-lrp-stepper]').forEach(function (st) {
      var feld = st.querySelector('input');
      var setzen = function (n) {
        var min = parseInt(feld.min || '1', 10), max = parseInt(feld.max || '99', 10);
        feld.value = Math.max(min, Math.min(max, n || min));
      };
      st.querySelector('[data-lrp-minus]').addEventListener('click', function () { setzen(parseInt(feld.value, 10) - 1); });
      st.querySelector('[data-lrp-plus]').addEventListener('click', function () { setzen(parseInt(feld.value, 10) + 1); });
      feld.addEventListener('change', function () { setzen(parseInt(feld.value, 10)); });
    });
  }

  function kauf() {
    alle(document, '[data-lrp-form]').forEach(function (form) {
      var btn = form.querySelector('[data-lrp-submit]');
      var fehler = form.querySelector('[data-lrp-fehler]');
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var id = parseInt(form.querySelector('[data-lrp-variante]').value, 10);
        var n = Math.max(1, parseInt((form.querySelector('[data-lrp-anzahl]') || {}).value, 10) || 1);
        kaufMit(btn, [{ id: id, quantity: n }], fehler);
      });
    });
    alle(document, '[data-lrp-ware-kauf]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        kaufMit(btn, [{ id: parseInt(btn.getAttribute('data-lrp-ware-kauf'), 10), quantity: 1 }], null);
      });
    });
  }

  /* ---------- Anfrage vorbefüllen ---------- */

  function formular() { return document.querySelector('[data-lrp-formular]'); }

  function markieren(feld) {
    var huelle = feld && feld.closest('.lrp-formular__feld');
    if (!huelle) return;
    huelle.classList.remove('ist-vorbefuellt');
    void huelle.offsetWidth;
    huelle.classList.add('ist-vorbefuellt');
    setTimeout(function () { huelle.classList.remove('ist-vorbefuellt'); }, 2600);
  }

  function vorbefuellen(a) {
    var f = formular();
    if (!f) return;
    var anliegen = a.getAttribute('data-lrp-anliegen') || 'Angebot';
    var sel = f.querySelector('[data-lrp-f-anliegen]');
    if (sel) {
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value === anliegen) { sel.selectedIndex = i; markieren(sel); break; }
      }
    }
    var menge = null;
    if (a.hasAttribute('data-lrp-menge')) {
      menge = parseInt(a.getAttribute('data-lrp-menge'), 10);
    } else if (a.hasAttribute('data-lrp-menge-aus')) {
      var wurzel = a.closest('[data-lrp-kauf]') || document;
      var quelle = wurzel.querySelector(a.getAttribute('data-lrp-menge-aus'));
      if (quelle) menge = parseInt(quelle.value, 10);
    }
    var anzahl = f.querySelector('[data-lrp-f-anzahl]');
    if (anzahl && menge > 0) { anzahl.value = menge; markieren(anzahl); }

    var text = f.querySelector('[data-lrp-f-text]');
    var name = a.getAttribute('data-lrp-angebot');
    var zeile = a.getAttribute('data-lrp-angebot-text');
    if (!zeile && name) zeile = 'Anfrage: ' + name + (menge > 0 ? ', ' + menge + ' Stück' : '') + '.';
    if (text && zeile) {
      if (/^(Anfrage:|Bitte schickt)[^\n]*/.test(text.value)) text.value = text.value.replace(/^(Anfrage:|Bitte schickt)[^\n]*/, zeile);
      else text.value = zeile + (text.value ? '\n' + text.value : '');
      markieren(text);
    }
  }

  function zumFormular(e) {
    var f = formular();
    if (!f) return;
    e.preventDefault();
    f.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#ContactForm');
    var name = f.querySelector('input[name="contact[Name]"]');
    if (name && !name.value) setTimeout(function () { name.focus({ preventScroll: true }); }, ruhig ? 0 : 700);
  }

  function anfrage() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-lrp-angebot], [data-lrp-anliegen]');
      if (!a) return;
      vorbefuellen(a);
      if (a.getAttribute('href') === '#ContactForm') zumFormular(e);
    });
  }

  /* ---------- Pumpwerk ---------- */

  function pumpwerk() {
    alle(document, '[data-lrp-pumpwerk]').forEach(function (sec) {
      var vol = parseFloat(sec.getAttribute('data-volumen')) || 20;
      var hubL = (parseFloat(sec.getAttribute('data-hub')) || 120) / 1000;
      var maxHub = Math.ceil(vol / hubL - 1e-9);
      var svg = sec.querySelector('[data-lrp-pw-svg]');
      var wasser = sec.querySelector('[data-lrp-pw-wasser]');
      var tank = sec.querySelector('[data-lrp-pw-tanktext]');
      var restEl = sec.querySelector('[data-lrp-pw-rest]');
      var hubEl = sec.querySelector('[data-lrp-pw-hub]');
      var abEl = sec.querySelector('[data-lrp-pw-ab]');
      var weiteEl = sec.querySelector('[data-lrp-pw-weite]');
      var pumpe = sec.querySelector('[data-lrp-pw-pumpe]');
      var fuellen = sec.querySelector('[data-lrp-pw-fuellen]');
      var hint = sec.querySelector('[data-lrp-pw-hint]');
      var hintText = hint ? hint.textContent : '';
      var live = sec.querySelector('[data-lrp-pw-live]');
      var gruppe = sec.querySelector('[data-lrp-pw-pulse]');
      var lanze = sec.querySelector('[data-lrp-pw-lanze]');
      var modi = alle(sec, '[data-lrp-pw-modus]');
      if (!svg || !pumpe) return;
      var hub = 0, modus = 'voll', takt = null, stopp = null, demo = null, demoAn = false;

      function zeichnen(rest) {
        if (rest === undefined) rest = Math.max(0, vol - hub * hubL);
        var anteil = rest / vol;
        if (wasser) wasser.style.transform = 'translateY(' + ((1 - anteil) * 236).toFixed(1) + 'px)';
        if (tank) tank.textContent = komma(rest, 1) + ' l';
        if (restEl) restEl.textContent = komma(rest, 1);
        if (hubEl) hubEl.textContent = String(hub);
        if (abEl) abEl.textContent = komma(Math.min(vol, vol - rest), 2);
        pumpe.style.setProperty('--anteil', (1 - anteil).toFixed(3));
        var leer = rest <= 0.0001;
        pumpe.disabled = leer;
        if (hint) hint.textContent = leer ? 'Tank leer. Über die 100-mm-Öffnung in Sekunden nachgefüllt.' : hintText;
        return leer;
      }

      function puls() {
        if (ruhig || !gruppe) return;
        var bahnen = modus === 'voll'
          ? alle(svg, '[data-lrp-pw-bahn="voll"]')
          : alle(svg, '.lrp-pw__facher');
        if (gruppe.childNodes.length > 16) return;
        bahnen.forEach(function (bahn) {
          var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          p.setAttribute('d', bahn.getAttribute('d'));
          p.setAttribute('pathLength', '1000');
          p.setAttribute('class', 'lrp-pw__puls');
          if (modus !== 'voll') p.style.strokeWidth = '5';
          gruppe.appendChild(p);
          requestAnimationFrame(function () { p.classList.add('laeuft'); });
          var weg = function () { if (p.parentNode) p.parentNode.removeChild(p); };
          p.addEventListener('animationend', weg);
          setTimeout(weg, 1600);
        });
      }

      function hubMachen() {
        if (hub >= maxHub) return;
        hub += 1;
        var leer = zeichnen();
        puls();
        if (lanze && !ruhig) neuStarten(lanze, 'hub');
        sec.classList.add('ist-pumpt');
        clearTimeout(stopp);
        stopp = setTimeout(function () { sec.classList.remove('ist-pumpt'); }, 650);
        if (leer) { halten(false); if (live) live.textContent = 'Tank leer nach ' + hub + ' Hüben.'; }
      }

      function halten(an) {
        clearInterval(takt);
        takt = null;
        pumpe.classList.toggle('ist-gedrueckt', !!an);
        if (an) takt = setInterval(hubMachen, 250);
      }

      function modusSetzen(m) {
        modus = m;
        svg.setAttribute('data-modus', m);
        modi.forEach(function (b) {
          var ja = b.getAttribute('data-lrp-pw-modus') === m;
          b.setAttribute('aria-pressed', String(ja));
          if (ja && weiteEl) weiteEl.textContent = 'über ' + b.getAttribute('data-weite');
        });
        if (live) live.textContent = (m === 'voll' ? 'Vollstrahl' : 'Sprühnebel') + ' eingestellt.';
      }

      function neuFuellen() {
        var start = Math.max(0, vol - hub * hubL);
        hub = 0;
        if (ruhig) { zeichnen(); return; }
        var t0 = null;
        var lauf = function (t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / 900);
          var w = 1 - Math.pow(1 - p, 3);
          zeichnen(start + (vol - start) * w);
          if (p < 1) requestAnimationFrame(lauf); else zeichnen();
        };
        requestAnimationFrame(lauf);
        if (hubEl) hubEl.textContent = '0';
      }

      function demoStopp() {
        if (!demoAn) return;
        demoAn = false;
        clearTimeout(demo);
      }

      function vorfuehren() {
        if (ruhig) return;
        demoAn = true;
        var folge = [];
        var i;
        for (i = 0; i < 9; i++) folge.push(['hub', 230]);
        folge.push(['modus:nebel', 700]);
        for (i = 0; i < 9; i++) folge.push(['hub', 230]);
        folge.push(['modus:voll', 900]);
        folge.push(['fuellen', 0]);
        var n = 0;
        var weiter = function () {
          if (!demoAn || n >= folge.length) { demoAn = false; return; }
          var s = folge[n++];
          if (s[0] === 'hub') hubMachen();
          else if (s[0] === 'fuellen') neuFuellen();
          else modusSetzen(s[0].split(':')[1]);
          demo = setTimeout(weiter, s[1]);
        };
        demo = setTimeout(weiter, 500);
      }

      pumpe.addEventListener('pointerdown', function (e) {
        if (e.button !== undefined && e.button !== 0) return;
        e.preventDefault();
        demoStopp();
        if (pumpe.setPointerCapture) { try { pumpe.setPointerCapture(e.pointerId); } catch (x) {} }
        hubMachen();
        halten(true);
      });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) { pumpe.addEventListener(ev, function () { halten(false); }); });
      pumpe.addEventListener('click', function (e) {
        if (e.detail === 0) { demoStopp(); hubMachen(); }
      });
      pumpe.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      modi.forEach(function (b) {
        b.addEventListener('click', function () { demoStopp(); modusSetzen(b.getAttribute('data-lrp-pw-modus')); });
      });
      if (fuellen) fuellen.addEventListener('click', function () { demoStopp(); neuFuellen(); });

      zeichnen();
      if (hatIO && !ruhig) {
        var io = new IntersectionObserver(function (e) {
          if (!e[0].isIntersecting) return;
          io.disconnect();
          vorfuehren();
        }, { threshold: 0.55 });
        io.observe(svg);
      }
    });
  }

  /* ---------- Aufbau mit Markierungen ---------- */

  function anatomie() {
    alle(document, '[data-lrp-anatomie]').forEach(function (sec) {
      var punkte = alle(sec, '[data-lrp-ana-punkt]');
      var teile = alle(sec, '[data-lrp-ana-teil]');
      var aktiv = 0;
      function waehle(n, hinScrollen) {
        aktiv = n;
        punkte.forEach(function (p) { p.classList.toggle('ist-aktiv', p.getAttribute('data-lrp-ana-punkt') === String(n)); });
        teile.forEach(function (t) {
          var ja = t.getAttribute('data-lrp-ana-teil') === String(n);
          t.classList.toggle('ist-aktiv', ja);
          var k = t.querySelector('[data-lrp-ana-wahl]');
          if (k) k.setAttribute('aria-expanded', String(ja));
          if (ja && hinScrollen) {
            var r = t.getBoundingClientRect();
            if (r.top < 90 || r.bottom > vh()) t.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'nearest' });
          }
        });
      }
      punkte.forEach(function (p) {
        var n = parseInt(p.getAttribute('data-lrp-ana-punkt'), 10);
        p.addEventListener('click', function () { waehle(n, window.matchMedia('(max-width: 989px)').matches); });
        if (feinZeiger) p.addEventListener('mouseenter', function () { waehle(n, false); });
      });
      alle(sec, '[data-lrp-ana-wahl]').forEach(function (k) {
        var n = parseInt(k.getAttribute('data-lrp-ana-wahl'), 10);
        k.addEventListener('click', function () { waehle(aktiv === n ? 0 : n, false); });
        if (feinZeiger) k.addEventListener('mouseenter', function () { if (aktiv !== n) waehle(n, false); });
      });
      waehle(1, false);
      var buehne = sec.querySelector('.lrp-ana__buehne');
      if (buehne && hatIO && !ruhig) {
        var io = new IntersectionObserver(function (e) {
          if (!e[0].isIntersecting) return;
          io.disconnect();
          einmal(buehne, 'lrp-ana-go', 2400);
        }, { threshold: 0.25 });
        if (!imBild(buehne)) io.observe(buehne);
      }
    });
  }

  /* ---------- Einsatzverlauf ---------- */

  function verlauf() {
    alle(document, '[data-lrp-verlauf]').forEach(function (sec) {
      var phasen = alle(sec, '[data-lrp-vl-phase]');
      var folien = alle(sec, '[data-lrp-vl-folie]');
      var punkte = alle(sec, '[data-lrp-vl-punkt]');
      var buehne = sec.querySelector('[data-lrp-vl-buehne]');
      if (!phasen.length || !hatIO) return;
      var wertEl = sec.querySelector('[data-lrp-vl-wert]');
      var einheitEl = sec.querySelector('[data-lrp-vl-einheit]');
      var labelEl = sec.querySelector('[data-lrp-vl-label]');
      var nrEl = sec.querySelector('[data-lrp-vl-nr]');
      var kennzahl = sec.querySelector('.lrp-vl__kennzahl');
      sec.classList.add('lrp-vl--live');
      var jetzt = 0;
      function aktiv(ph) {
        var n = parseInt(ph.getAttribute('data-lrp-vl-phase'), 10);
        if (n === jetzt) return;
        jetzt = n;
        phasen.forEach(function (p) { p.classList.toggle('ist-aktiv', p === ph); });
        var foto = false;
        folien.forEach(function (f) {
          var ja = f.getAttribute('data-lrp-vl-folie') === String(n);
          f.classList.toggle('ist-aktiv', ja);
          if (ja) foto = f.classList.contains('lrp-vl__folie--foto');
        });
        if (buehne) buehne.classList.toggle('ist-foto', foto);
        punkte.forEach(function (p) {
          var i = parseInt(p.getAttribute('data-lrp-vl-punkt'), 10);
          p.classList.toggle('ist-aktiv', i === n);
          p.classList.toggle('ist-erledigt', i < n);
        });
        if (wertEl) wertEl.textContent = ph.getAttribute('data-wert') || '';
        if (einheitEl) einheitEl.textContent = ph.getAttribute('data-einheit') || '';
        if (labelEl) labelEl.textContent = ph.getAttribute('data-label') || '';
        if (nrEl) nrEl.textContent = (n < 10 ? '0' : '') + n;
        if (kennzahl && !ruhig) neuStarten(kennzahl, 'wechselt');
      }
      var io = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) { if (e.isIntersecting) aktiv(e.target); });
      }, { rootMargin: '-46% 0px -46% 0px' });
      phasen.forEach(function (p) { io.observe(p); });
      aktiv(phasen[0]);
    });
  }

  /* ---------- Planer ---------- */

  function planer() {
    alle(document, '[data-lrp-planer]').forEach(function (sec) {
      var preis = parseInt(sec.getAttribute('data-preis'), 10) || 0;
      var volumen = parseFloat(sec.getAttribute('data-volumen')) || 20;
      var leer = parseFloat(sec.getAttribute('data-leer')) || 2;
      var hubs = parseInt(sec.getAttribute('data-hubs'), 10) || 166;
      var variante = parseInt(sec.getAttribute('data-variante'), 10);
      var regler = sec.querySelector('[data-lrp-p-regler]');
      var saecke = alle(sec, '.lrp-plan__sack');
      var vorlagen = alle(sec, '[data-lrp-p-vorlage]');
      var kaufBtn = sec.querySelector('[data-lrp-p-kauf]');
      var angebot = sec.querySelector('[data-lrp-p-angebot]');
      var fehler = sec.querySelector('[data-lrp-p-fehler]');
      if (!regler) return;
      var setze = function (sel, text) {
        alle(sec, sel).forEach(function (el) {
          if (el.textContent === text) return;
          el.textContent = text;
          if (!ruhig) neuStarten(el, 'lrp-wert-tickt');
        });
      };
      function rechne() {
        var n = parseInt(regler.value, 10);
        var max = parseInt(regler.max, 10);
        regler.style.setProperty('--anteil', ((n - 1) / Math.max(1, max - 1)).toFixed(3));
        setze('[data-lrp-p-anzahl]', String(n));
        setze('[data-lrp-p-wasser]', zahlFmt.format(n * volumen));
        setze('[data-lrp-p-hubs]', zahlFmt.format(n * hubs));
        setze('[data-lrp-p-gewicht]', zahlFmt.format(n * leer));
        setze('[data-lrp-p-netto]', geld(preis * n));
        setze('[data-lrp-p-brutto]', geld(Math.round(preis * n * 1.19)));
        setze('[data-lrp-p-k-anzahl]', String(n));
        setze('[data-lrp-p-a-anzahl]', String(n));
        if (angebot) angebot.setAttribute('data-lrp-menge', String(n));
        var j = 0;
        saecke.forEach(function (s, i) {
          var an = i < n;
          var war = s.classList.contains('ist-an');
          s.classList.toggle('ist-an', an);
          if (an && !war && !ruhig) { s.style.setProperty('--j', String(j++)); neuStarten(s, 'ist-neu'); }
        });
        vorlagen.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-lrp-p-vorlage') === String(n))); });
      }
      regler.addEventListener('input', rechne);
      vorlagen.forEach(function (b) {
        b.addEventListener('click', function () { regler.value = b.getAttribute('data-lrp-p-vorlage'); rechne(); });
      });
      if (kaufBtn) kaufBtn.addEventListener('click', function () {
        kaufMit(kaufBtn, [{ id: variante, quantity: parseInt(regler.value, 10) || 1 }], fehler);
      });
      rechne();
    });
  }

  /* ---------- Pressebanner ---------- */

  function presse() {
    alle(document, '[data-lrp-presse]').forEach(function (p) {
      var band = p.querySelector('.lrp-presse__band');
      if (!band) return;
      var setzen = function () { p.style.setProperty('--lauf', Math.max(24, Math.round(band.scrollWidth / 42)) + 's'); };
      setzen();
      window.addEventListener('resize', setzen, { passive: true });
    });
  }

  /* ---------- Kaufleiste ---------- */

  function leiste() {
    var st = document.querySelector('[data-lrp-sticky]');
    if (!st || !hatIO) return;
    var kaufForm = document.querySelector('[data-lrp-form]');
    var kontakt = document.getElementById('ContactForm');
    var fuss = document.querySelector('footer, .footer, #shopify-section-footer');
    var kaufSichtbar = true, kontaktSichtbar = false, fussSichtbar = false, tief = false;

    function pruefen() {
      var zeigen = tief && !kaufSichtbar && !kontaktSichtbar && !fussSichtbar;
      if (zeigen) {
        if (st.hidden) {
          st.hidden = false;
          st.classList.add('ist-weg');
          requestAnimationFrame(function () { requestAnimationFrame(function () { st.classList.remove('ist-weg'); }); });
        } else st.classList.remove('ist-weg');
      } else if (!st.hidden) {
        st.classList.add('ist-weg');
      }
    }
    if (kaufForm) new IntersectionObserver(function (e) { kaufSichtbar = e[0].isIntersecting; pruefen(); }).observe(kaufForm);
    else kaufSichtbar = false;
    if (kontakt) new IntersectionObserver(function (e) { kontaktSichtbar = e[0].isIntersecting; pruefen(); }).observe(kontakt);
    if (fuss) new IntersectionObserver(function (e) { fussSichtbar = e[0].isIntersecting; pruefen(); }).observe(fuss);
    window.addEventListener('scroll', function () {
      var t = window.scrollY > 600;
      if (t !== tief) { tief = t; pruefen(); }
    }, { passive: true });

    var knopf = st.querySelector('[data-lrp-sticky-kauf]');
    if (knopf && kaufForm && window.fetch) {
      knopf.addEventListener('click', function (e) {
        e.preventDefault();
        var label = knopf.innerHTML;
        var id = parseInt(kaufForm.querySelector('[data-lrp-variante]').value, 10);
        var n = Math.max(1, parseInt((kaufForm.querySelector('[data-lrp-anzahl]') || {}).value, 10) || 1);
        knopf.classList.add('ist-ok');
        inDenWarenkorb([{ id: id, quantity: n }]).then(function () {
          knopf.innerHTML = HAKEN + '<span>Im Korb</span>';
          setTimeout(function () { knopf.classList.remove('ist-ok'); knopf.innerHTML = label; }, 2400);
        }).catch(function () {
          knopf.classList.remove('ist-ok');
          var ziel = document.getElementById('kaufen');
          if (ziel) ziel.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth' });
        });
      });
    }
  }

  /* ---------- Start ---------- */

  function start() {
    stepper();
    galerie();
    kauf();
    anfrage();
    pumpwerk();
    anatomie();
    verlauf();
    planer();
    presse();
    buehne();
    funken();
    einblenden();
    schleifen();
    zaehlen();
    leiste();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
